export default __webpack_public_path__ + "static/media/post-company-4.42220a9a.png";